import "./kendo.dataviz.js";
import "./kendo.mobile.js";
    "bundle all";
export default kendo;
